import React from 'react'
import { HeroContainer, HeroWrapper, HeroText, HeroHeading,
HeroP, HeroImage, Image, HeroBtn, SocialIcons, SocialIconLink, AddressContact,
Add, Button} from './HeroElement'
import img from "../../Images/s6.png"
// import { Button } from '../ButtonElement'
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from "react-icons/fa"
import {AiTwotoneHome, AiTwotoneMail, AiTwotonePhone} from "react-icons/ai";
// import {Link} from "react-router-dom"



const Hero = () => {
    return (
        <HeroContainer id="info">
            <HeroWrapper>
                <HeroText>
                    <HeroHeading>Welcome to I<span style={{color:"crimson", fontStyle:"italic"}}>D</span>ev Group of Schools</HeroHeading>
                    <HeroP>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ea atque tenetur, quo quos sint placeat 
                            quibusdam odit excepturi ratione nobis ipsam exercitationem illum qui? Dolorum est 
                            ex quas autem ullam.         
                    </HeroP>
                    <HeroBtn>
                       <Button to="/sign-up">Get Started</Button>
                    </HeroBtn>

                    <SocialIcons>
                            <SocialIconLink href="/" target="_blank" aria-label="Facebook">
                                <FaFacebook/>
                            </SocialIconLink>
                            <SocialIconLink href="/" target="_blank" aria-label="Instagram">
                                <FaInstagram/>
                            </SocialIconLink>
                            <SocialIconLink href="/" target="_blank" aria-label="Twitter">
                                <FaTwitter/>
                            </SocialIconLink>
                            <SocialIconLink href="/" target="_blank" aria-label="LinkedIn">
                                <FaLinkedin/>
                            </SocialIconLink>
                        </SocialIcons>

                        <AddressContact>
                        <Add>
                <AiTwotoneMail/> admin@gmail.com</Add>
               
                            <Add>
                            <AiTwotonePhone/> +11223445858
                            </Add>

                            <Add>
                            <AiTwotoneHome/> 1234 Funfun Main Road, example 2344
                            </Add>
                                                   
                            </AddressContact>
                        
                        
                </HeroText>
                <HeroImage>
                    <Image src={img} alt="school"/>
                </HeroImage>
            </HeroWrapper>
        </HeroContainer>
    )
}

export default Hero
